// function addSlideToEventIndexSlider() {
//     let wrapper = $('.js-event-index-slider');
//     let item = $('.js-event-index-slider-item');

//     if (item.length > 4 && item.length % 2 !== 0) {
//         let middleIndex = Math.floor(item.length / 2);

//         item.eq(middleIndex).clone(true, true).appendTo(wrapper);
//     }
// }

// if ($('.js-event-index-slider').length) {
//     addSlideToEventIndexSlider();
// }

$('.event-index__slider__wrapper__items').slick({
    arrows: true,
    appendArrows: '.event-index__slider__wrapper__head__nav',
    prevArrow: $('.event-index__slider__wrapper__head__nav__left'),
    nextArrow: $('.event-index__slider__wrapper__head__nav__right'),
    dots: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    fade: false,
    infinite: false,
    draggable: false,
    swipe: true,
    touchMove: true,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 768,
            settings: {
                centerMode: true,
                slidesToShow: 1,
            },
        },
    ],
});

const navItemsEventIndex = document.querySelectorAll('.js-ticket-nav-item');
const ticketTabsEvebtIndex = document.querySelectorAll('.js-ticket-tab-item');

navItemsEventIndex.forEach(function (item) {
    item.addEventListener('click', function () {
        navItemsEventIndex.forEach(function (item) {
            item.classList.remove('active');
        });
        this.classList.add('active');
        ticketTabsEvebtIndex.forEach((el) => {
            el.classList.remove('active');
        });
        document
            .querySelector('[data-tab="' + this.dataset.tabOpen + '"]')
            .classList.add('active');
        eventAdaptiveHeight();
    });
});

function eventAdaptiveHeight() {
    if (window.innerWidth >= 1440) {
        ticketTabsEvebtIndex.forEach(function (item) {
            const titles = item.querySelectorAll('.title');
            let maxHeight = 0;
            titles.forEach(function (item) {
                if (item.offsetHeight > maxHeight) {
                    maxHeight = item.offsetHeight;
                    item.style.minHeight = `${maxHeight}px`;
                }
            });
            titles.forEach(function (item) {
                item.style.minHeight = `${maxHeight}px`;
            });
        });
    }
}

eventAdaptiveHeight();

window.addEventListener('resize', function () {
    eventAdaptiveHeight();
});

const eventBannerClose = document.querySelector('.event-index-banner__close');

if (eventBannerClose) {
    eventBannerClose.addEventListener('click', function () {
        eventBannerClose.parentNode.classList.add('dn');
    });
}

const eventIndexAccordItems = document.querySelectorAll(
    '.event-index__up-next__items__item'
);

eventIndexAccordItems.forEach(function (item) {
    const btn = item.querySelector(
        '.event-index__up-next__items__item__accord'
    );
    const accBody = item.querySelector('.event-index__accord');

    item.addEventListener('click', function () {
        if (window.innerWidth <= 768) {
            btn.classList.toggle('active');
            if (btn.classList.contains('active')) {
                accBody.classList.add('active');
                accBody.style.height = `${accBody.scrollHeight}px`;
            } else {
                accBody.classList.remove('active');
                accBody.style.height = `${0}px`;
            }
        }
    });
    window.addEventListener('resize', function () {
        btn.classList.remove('active');
        accBody.classList.remove('active');
        if (window.innerWidth >= 768) {
            accBody.style.height = 'auto';
        } else {
            accBody.style.height = '0px';
        }
    });
});
